import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-facebook\"><path d=\"M30.23,0H1.77A1.77,1.77,0,0,0,0,1.77V30.23A1.77,1.77,0,0,0,1.77,32H17.09V19.61H12.92V14.78h4.17V11.22c0-4.13,2.52-6.38,6.21-6.38A34.22,34.22,0,0,1,27,5V9.34H24.47c-2,0-2.39,1-2.39,2.35v3.08h4.78l-.62,4.83H22.08V32h8.15A1.77,1.77,0,0,0,32,30.23V1.77A1.77,1.77,0,0,0,30.23,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/facebook.svg
// module id = 132
// module chunks = 0 1 2